import { Product } from "#sitis/internal/controllers/products/models/Product";
export const getItemsWithPagination = (res) => ({
  items: res._data,
  pagination: {
    pageCount: Number.parseFloat(res?.headers?.get("x-pagination-page-count") || "0"),
    totalCount: Number.parseFloat(res?.headers?.get("x-pagination-total-count") || "0")
  }
});
export class GetProductUseCase {
  constructor(agent) {
    this.agent = agent;
  }
  async getProductBySlug(params) {
    try {
      const queryParams = params.extensions?.join(",");
      const productRes = await this.agent.get(`/products/${params.slug}`, {
        query: {
          expand: queryParams
        }
      }).then((res) => res._data);
      return new Product(productRes).toJSON();
    } catch (ex) {
      throw ex;
    }
  }
  async getProducts(categorySlug, queryParamsProps) {
    try {
      const {
        filters,
        perPage,
        currentPage: page,
        sort,
        extensions,
        filterSlugs,
        basePath
      } = queryParamsProps;
      let queryParams = filterSlugs?.map((s) => `filter[slug][]=${s}`) || [];
      if (page) {
        queryParams.push(`page=${page}`);
      }
      if (perPage) {
        queryParams.push(`per-page=${perPage}`);
      }
      if (sort) {
        queryParams.push(`sort=${sort}`);
      }
      if (filters && filters.length) {
        queryParams = [...queryParams, ...filters];
      }
      if (extensions && extensions.length) {
        const formattedExtensions = extensions.join(",");
        queryParams.push(`expand=${formattedExtensions}`);
      }
      let query = queryParams.join("&");
      if (query) {
        query = `?${query}`;
      }
      const res = await this.agent.get(`${basePath}/${categorySlug}/products${query}`);
      const productsDTO = (res?._data || []).map((product) => new Product(product).toJSON());
      return getItemsWithPagination({
        headers: res.headers,
        _data: productsDTO
      });
    } catch (ex) {
      throw ex;
    }
  }
  async getRelatedProducts(slug, extensions) {
    try {
      const queryParams = [];
      if (extensions && extensions.length) {
        const formattedExtensions = extensions.join(",");
        queryParams.push(`expand=${formattedExtensions}`);
      }
      let query = queryParams.join("&");
      if (query) {
        query = `?${query}`;
      }
      const productsRes = await this.agent.get(`/products/${slug}/related${query}`);
      let products = [];
      if (productsRes._data) {
        products = productsRes._data.map((data) => new Product(data).toJSON());
      }
      return products;
    } catch (e) {
      throw e;
    }
  }
  async getRecentlyProducts(extensions) {
    try {
      const queryParams = [];
      if (extensions.length) {
        const formattedExtensions = extensions.join(",");
        queryParams.push(`expand=${formattedExtensions}`);
      }
      let query = queryParams.join("&");
      if (query) {
        query = `?${query}`;
      }
      const productsRes = await this.agent.get(`/recently-viewed${query}`).then((res) => res._data);
      let products = [];
      if (productsRes) {
        products = productsRes.map((data) => new Product(data).toJSON());
      }
      return products;
    } catch (ex) {
      throw ex;
    }
  }
  async getSameProducts(slug, extensions) {
    try {
      const queryParams = [];
      if (extensions && extensions.length) {
        const formattedExtensions = extensions.join(",");
        queryParams.push(`expand=${formattedExtensions}`);
      }
      let query = queryParams.join("&");
      if (query) {
        query = `?${query}`;
      }
      const productsRes = await this.agent.get(`/products/${slug}/same${query}`).then((res) => res._data);
      let products = [];
      if (productsRes) {
        products = productsRes.map((data) => new Product(data).toJSON());
      }
      return products;
    } catch (ex) {
      throw ex;
    }
  }
}
